export default "__VITE_ASSET__C4U11dOq__"